import React from 'react';
import {
    handleCheckbox,
    handleRadio,
    handleSequence,
    autoFocusNext,
    allowOnlyNumberInput,countWords
} from '../helpers/Fields';
const $ = window.$;

export default class Virtualkeyboard extends React.Component {

    constructor(props) {
        super(props);
    }

    // VirtualKeyboard(seqof) {
        
    //     var languages = {
    //         "ar": {
    //             layout: "ms-Arabic (101)",
    //             name: "Arabic (\u0627\u0644\u0639\u0631\u0628\u064a\u0629)"
    //         },
    //         "de": {
    //             layout: "ms-German",
    //             name: "German (Deutsch)"
    //         },
    //         "en": {
    //             layout: "qwerty",
    //             name: "English"
    //         },
    //         "tr": {
    //             layout: "ms-Turkish F",
    //             name: "Turkish (T\u00fcrk\u00e7e)"
    //         },
    //         "tm": {
    //             layout: "ms-Tamil",
    //             name: "ms-Tamil"
    //         },
    //         "fr": {
    //             layout: "ms-Belgian French",
    //             name: "ms-Belgian French"
    //         }
    //     }

    //     function selectLang(kb, lang) {
    //         var obj = languages[lang];
    //         if (obj) {
    //             kb.options.language = lang;
    //             kb.redraw(obj.layout);
    //         }
    //     };

    //     function addLang(kb) {
    //         var html = '';
    //         //console.log("call");
    //         html = '<div>Select Language: <select>';
    //         Object.keys(languages).forEach(function (language) {
    //             html += `<option value="${language}">${languages[language].name}</option>`;
    //         });
    //         kb.$keyboard.prepend(html + '</select></div>');

    //         kb.$keyboard.find('select')
    //             .val(kb.options.language || "en")
    //             .click(function () {
    //                 var el = this;
    //                 setTimeout(function () {
    //                     el.focus();
    //                 }, 100);
    //             })
    //             .change(function () {
    //                 selectLang(kb, this.value);
    //             });
    //     }

    //     $('#keyboard' + seqof).on('beforeVisible', function (e, kb) {
    //         addLang(kb);
    //     }).keyboard({ usePreview: false })             // activate the typing extension
    //         .addTyping({ showTyping: true, delay: 250 });
    //     $("#vkbox_" + seqof).prop('disabled', true);
    //     // $('#keyboard' + seqof).focus();
    //     // $('#keyboard' + seqof).focusout();

    //     var clipboard = new Clipboard('.bf');
    //     clipboard.on('success', function(e) {
    //     console.log(e); 
    //     });
    //     clipboard.on('error', function(e) {
    //     console.log(e);
    //     });


    // }
  
           
     alpha(item) {
        var quesid=document.getElementById('keyboard'+this.props.qus_id);
        var input = quesid;
        if (document.selection) {
            input.focus();
            let range = document.selection.createRange();
            range.text = item;
            range.select();
        }
        else if (input.selectionStart || input.selectionStart === '0') {
            var startPos = input.selectionStart;
            var endPos = input.selectionEnd;
            var cursorPos = startPos;
            var scrollTop = input.scrollTop;
            var baselength = 0;
            input.value = input.value.substring(0, startPos)
                + item
                + input.value.substring(endPos, input.value.length);
            cursorPos += item.length;
            input.focus();
            input.selectionStart = cursorPos;
            input.selectionEnd = cursorPos;
            input.scrollTop = scrollTop;
        }
        else {
            input.value += item;
            input.focus();
        }
    }
    
    // copier() {
    //     document.conversion.saisie.focus();
    //     document.conversion.saisie.select();
    //     let CopiedTxt = document.selection.createRange();
    //     CopiedTxt.execCommand("Copy");
    // }
    
    //  copy() {
    //     let textRange = document.conversion.saisie.createTextRange();
    //     textRange.execCommand("Copy");
    //     textRange = "";
    // }
    
    
    // annuler() {
    //     let car;
    //     car = document.conversion.saisie.value;
    //     car = car.replace(/\u200b/g, "");
    //     document.conversion.saisie.value = car;
    // }
    render() {
        let vkdata=this.props;

        // var ca;
        // function transit() {
        // ca = document.conversion.saisie.value;
        // document.bp.typedText.value=ca;
        // document.bp.submit(); 
        // }

        return (
            <div>
                {/* <textarea name={vkdata.qus_id} id={`keyboard${vkdata.qus_id}`}  className={vkdata.validate} rows="3" style={{ height: "inherit", resize: "none" }} onBlur={(e)=>countWords(e)} data-total-words={vkdata.data_maxword}></textarea>
                <div id="wrap">
                    <button id={`vkbox_${vkdata.qus_id}`} onClick={() => this.VirtualKeyboard(vkdata.qus_id)}>Virtual Keyboard</button>
                </div>
                <div className="word-count">
                    <span className="balance-words"></span>
                    <span className="typing-words"></span>
                </div> */}
                {/* <form name="conversion"> */}
        {/* <div className="delc"> 
          <br />
          <input type="reset" style={{background: 'url(https://www.lexilogos.com/images/effacer.png) center right no-repeat', paddingRight: '787px', cursor: 'pointer', width: '24px', height: '16px', borderWidth: '0 0 0 0'}} />
        </div> */}
        <div align="center">
          <textarea name={vkdata.qus_id} id={`keyboard${vkdata.qus_id}`}  className={vkdata.validate} rows="3"  onBlur={(e)=>countWords(e)} data-total-words={vkdata.data_maxword} defaultValue={""}></textarea>
          <div className="word-count">
                    <span className="balance-words"></span>
                    <span className="typing-words"></span>
                </div> 
        </div>
        <br />
        <div align="center">
          {/* <input type="button1" className="bf" data-clipboard-action="copy" data-clipboard-target="#bar" defaultValue="copy" />
          <input type="button" className="bf" onClick="alpha(' ')" defaultValue="space" /><input type="button" onClick="conversion.saisie.rows=8;conversion.saisie.focus()" defaultValue="small frame" className="bf" /><input type="button1" onClick="conversion.saisie.rows=40;conversion.saisie.focus()" defaultValue="large frame" className="bf" />
          <br />
          <br /> */}
          <table className="tab-kb" style={{backgroundColor: '#2b93d8'}}>
            <tbody><tr> 
                <td><input type="button1" className="bt" onClick={() => this.alpha('À')} defaultValue="À" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Â')} defaultValue="Â" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Æ')} defaultValue="Æ" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ç')} defaultValue="Ç" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('É')} defaultValue="É" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('È')} defaultValue="È" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ê')} defaultValue="Ê" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ë')} defaultValue="Ë" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Î')} defaultValue="Î" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ï')} defaultValue="Ï" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ô')} defaultValue="Ô" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Œ')} defaultValue="Œ" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ù')} defaultValue="Ù" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Û')} defaultValue="Û" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ü')} defaultValue="Ü" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('Ÿ')} defaultValue="Ÿ" /></td>
              </tr>
              <tr> 
                <td><input type="button1" className="bt" onClick={() => this.alpha('à')} defaultValue="à" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('â')} defaultValue="â" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('æ')} defaultValue="æ" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ç')} defaultValue="ç" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('é')} defaultValue="é" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('è')} defaultValue="è" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ê')} defaultValue="ê" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ë')} defaultValue="ë" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('î')} defaultValue="î" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ï')} defaultValue="ï" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ô')} defaultValue="ô" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('œ')} defaultValue="œ" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ù')} defaultValue="ù" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('û')} defaultValue="û" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ü')} defaultValue="ü" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('ÿ')} defaultValue="ÿ" /></td>
              </tr>
            </tbody></table>
          <table className="tab-kb" style={{backgroundColor: '#2b93d8'}}>
            <tbody><tr> 
                <td><input type="button1" className="bt" onClick={() => this.alpha('«')} defaultValue="«" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('“')} defaultValue="“" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('”')} defaultValue="”" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('—')} defaultValue="—" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('»')} defaultValue="»" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('–')} defaultValue="–" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('’')} defaultValue="’" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha('…')} defaultValue="…" /></td>
                <td><input type="button1" className="bt" onClick={() => this.alpha(' ')} defaultValue=" " title="Narrow no-break space" /></td>
              </tr>
            </tbody></table> 
          <br />
          {/* <br />
          <br />
          <a className="lb" href="#" onClick="transit()">spell checker</a>  */}
        </div>
      {/* </form> */}
      
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Virtualkeyboard.js